module.exports = __webpack_public_path__ + "static/media/about_layout.cbb4e8ed.png";